import {
    Purchase,
    IOnlineOrderHistory,
    SyncPurchases,
    IGlobalOrderDetails,
    IRetailOrderHistory
} from '@interfaces/myPurchasesInterfaces';
import * as actionTypes from './actionTypes';

//ONLINE ORDERS

export const getEncryptedOnlineOrderIdPending = () => {
    return {
        type: actionTypes.GET_ENCRYPTED_ONLINE_ORDER_ID_PENDING,
    };
};

export const getEncryptedOnlineOrderIdSuccess = (encodedOrderId: string) => {
    return {
        type: actionTypes.GET_ENCRYPTED_ONLINE_ORDER_ID_SUCCESS,
        encodedOrderId: encodedOrderId,
    };
};

export const getEncryptedOnlineOrderIdError = () => {
    return {
        type: actionTypes.GET_DASHBOARD_INFORMATIONS_ERROR,
    };
};

export const getOnlineOrdersHistoryPending = () => {
    return {
        type: actionTypes.GET_ONLINE_ORDERS_HISTORY_PENDING,
    };
};

export const getOnlineOrdersHistorySuccess = (onlineOrders: IOnlineOrderHistory[]) => {
    return {
        type: actionTypes.GET_ONLINE_ORDERS_HISTORY_SUCCESS,
        onlineOrders: onlineOrders,
    };
};

export const getOnlineOrdersHistoryError = () => {
    return {
        type: actionTypes.GET_ONLINE_ORDERS_HISTORY_ERROR,
    };
};

export const getRetailOrderHistoryPending = () => {
    return {
        type: actionTypes.GET_ORDER_RETAIL_HISTORY_PENDING,
    };
};

export const getRetailOrderHistoryError = () => {
    return {
        type: actionTypes.GET_ORDER_RETAIL_HISTORY_ERROR,
    };
};

export const getRetailOrderHistorySuccess = (retailOrders: IRetailOrderHistory[]) => {
    return {
        type: actionTypes.GET_ORDER_RETAIL_HISTORY_SUCCESS,
        retailOrders: retailOrders,
    }
}

export const getPrescriptionInfoDetails = (prescriptionInfoDetails: any) => {
    return {
        type: actionTypes.GET_PRESCRIPTION_INFO,
        prescriptionInfoDetails: prescriptionInfoDetails
    }
};

////ORDER DETAILS

export const getGlobalOrderDetailsPending = () => {
    return {
        type: actionTypes.GET_GLOBAL_ONLINE_ORDER_DETAILS_PENDING,
    };
};

export const getGlobalOrderDetailsSuccess = (globalOrderDetails: IGlobalOrderDetails) => {
    return {
        type: actionTypes.GET_GLOBAL_ONLINE_ORDER_DETAILS_SUCCESS,
        globalOrderDetails: globalOrderDetails,
    };
};

export const getGlobalOrderDetailsError = () => {
    return {
        type: actionTypes.GET_GLOBAL_ONLINE_ORDER_DETAILS_ERROR,
    };
};

export const getOrderItemCarrierUrlPending = () => {
    return {
        type: actionTypes.GET_ORDER_ITEM_CARRIER_URL_PENDING,
    };
};

export const getOrderItemCarrierUrlSuccess = (orderItemCarrierUrl: string) => {
    return {
        type: actionTypes.GET_ORDER_ITEM_CARRIER_URL_SUCCESS,
        orderItemCarrierUrl: orderItemCarrierUrl,
    };
};

export const getOrderItemCarrierUrlError = () => {
    return {
        type: actionTypes.GET_ORDER_ITEM_CARRIER_URL_ERROR,
    };
};

//IN-STORE PURCHASES

export const saveSearchFilters = (searchFilters: SyncPurchases) => {
    return {
        type: actionTypes.SAVE_IN_STORE_PURCHASES_SEARCH_FILTERS,
        searchFilters: searchFilters,
    };
};

export const getMyPurchasesPending = () => {
    return {
        type: actionTypes.GET_IN_STORE_PURCHASES_MY_PURCHASES_PENDING,
    };
};

export const getMyPurchasesSuccess = (purchases: Purchase[]) => {
    return {
        type: actionTypes.GET_IN_STORE_PURCHASES_MY_PURCHASES_SUCCESS,
        purchases: purchases,
    };
};

export const getMyPurchasesError = () => {
    return {
        type: actionTypes.GET_IN_STORE_PURCHASES_MY_PURCHASES_ERROR,
    };
};
